
//Web Backend URL
//export const BASE_URL = 'http://192.168.1.205:12670';
export const BASE_URL = 'https://www.proxima-universe.com/ecosystem';

//Game URL
export const GAME_URL = 'https://ckproxima.github.io/ProximaV2Github/';


export const MTV_NETWORK = {
    chainId: 62621,
    rpcUrl: 'https://rpc.mtv.ac',
};


//Website Access Contracts
export const Login_CONCTRACT = '0xE8C3412CF12E4a358BaF731C0BdaD57426B08bB8';
export const Subscription_CONTRACT = '';


//Game Mounting Contracts
export const FighterMOUNT_CONTRACT = '0xF0270da8476C5525a3Db2071Adb3c484018033fc';
export const BotMOUNT_CONTRACT = '';
export const CrewMOUNT_CONTRACT = '';

//Item Contracts
export const AmmoBasicContract = '';
export const ArmorBasicContract = '';
export const SkillToken = '';
export const LifeToken = '';
export const LevelModContract = '';

//Resource Contracts


//Proxima Token Contracts
export const PROX_TOKEN = '0x9029d1dEDa00e166De55406eAB2608E4efC66D7b';

//Proxima NFT Contracts
export const TELLURIAN_FIGHTER = '0x70533ad4FaD157351294ee906cC2F09c922d213a';
export const CELESTIAL_FIGHTER = '0xD97333f247B3d343F8886320beed80bf6CCa9D77';
export const MACHINA_FIGHTER = '0xD8b9c28A7275107cc1B1BC80e578B4d888386A38';
export const TELLURIAN_BOT = '0xa3cdc82351e9c59629fea6806a7433d2d9c999dd';
export const CELESTIAL_BOT = '0x4236a1b37248d6e44500e3e7fb00bdee9278f12f';
export const MACHINA_BOT = '0x74790be6eb1195f27c50535beabc6dc0431bce47';
export const SATOSHI_BOT = '0x02b56633fc76481a0f4be3740ddeab24e86bf6a0';

//Crew Contracts
export const LITTLEBITS = '0x668a14de36d7a24a74e2d6d77bcaa6d5c58376e7';
export const PANDACREW = '0xad4aec2bc33e95b509d71ac4d911c0cef218f570';
export const ETHEREALWORMS = '0x630b97e985a4782e8ae0a5e000b8ce47a85407dd';
export const LITTLEWORMS = '0x20a1fd7bd6aced8ec85a3589b6ab0430ecbd66a8';
export const MULTIWORMS = '0x4551c11b22fdd733a0328c62d6ef4e4c6496dada';
export const MULTIWRIGGLERS = '0xd162d3fb9f9f6f59592c62676e1771b96df5a01e';
export const PROXIMAWORMS = '0x6fa7da0e17db762f242a7a0b005162ebba42f6e3';
export const PUNKWORMS = '0xcbe37ec780a827727866ebd80d3674adb711d62c';
export const WILDWORMS = '0x611af5254fd862a76cb4bb5bbc37b97a4e6fab4b';
